__turbopack_context__.v({
  "main-swiper": "PhotoAlbum-module__cldn-q__main-swiper",
  "swiper-slide": "PhotoAlbum-module__cldn-q__swiper-slide",
  "swiper-wrapper": "PhotoAlbum-module__cldn-q__swiper-wrapper",
  "thumbBar": "PhotoAlbum-module__cldn-q__thumbBar",
  "thumbImg": "PhotoAlbum-module__cldn-q__thumbImg",
  "thumbSlide": "PhotoAlbum-module__cldn-q__thumbSlide",
});
